<div class="modal-header">
  <span class="modal-title">{{ title | translate }}</span>
  <div class="close" aria-label="Close" (click)="dismiss()">
    <fa-icon [icon]="['fas', 'times']"></fa-icon>
  </div>
</div>
<div class="modal-body">
  
  {{ message | translate }}
  
  <div *ngIf="object" class="mt-2">
    <app-object-dialog-recap [objectType]="objectType" [object]="object"></app-object-dialog-recap>
  </div>

</div>
<div class="modal-footer">
  <button type="button" ngbAutoFocus class="btn btn-nc btn-secondary" style="min-width:100px;" (click)="decline()">
    {{ 'shared.confirmationDialog.button.cancel' | translate}}
  </button>
  <button type="button" class="btn btn-nc btn-primary" style="min-width:100px;" (click)="accept()">
    {{ 'shared.confirmationDialog.button.confirm' | translate}}
  </button>
</div>